
import { supabase } from '@/integrations/supabase/client';

/**
 * Adds a new year to the database, with validation and formatting
 */
export const addYear = async (year: string): Promise<void> => {
  let baseYear = year;
  if (year.includes('/')) {
    baseYear = year.split('/')[0];
  }
  
  if (!/^\d{4}$/.test(baseYear)) {
    throw new Error('Invalid year format. Please use YYYY or YYYY/YYYY+1');
  }

  const { error } = await supabase
    .from('years')
    .insert([{ year: baseYear }])
    .select();
  
  if (error && error.code !== '23505') {
    throw error;
  }
};
